import { AsyncPaginate } from "react-select-async-paginate";

import { getTenant } from "../../utils/tenantManager";
import { getScaleMakesApi } from "../../services/operation/scale/scaleMakeService";

type OptionType = {
  value: string;
  label: string;
  data?: any;
  __isNew__?: boolean;
};

type Props = {
  value: OptionType | null;
  onChange: (value: OptionType | null) => void;
};

export default function ScaleMakeAsyncSelect({ value, onChange }: Props) {
  const tenantId = getTenant();

  type OptionType = {
    value: string;
    label: string;
    data?: any;
    __isNew__?: boolean;
  };

  type Additional = {
    page: number;
  };

  const loadOptions = async (
    search: string,
    _loadedOptions: readonly OptionType[],
    additional?: Additional,
  ) => {
    const page = additional?.page ?? 1;

    const res = await getScaleMakesApi(search, page, tenantId!);

    const options: OptionType[] = res.data.map((x: any) => ({
      value: x.id,
      label: x.name,
      data: x,
    }));

    if (
      page === 1 &&
      search.trim() &&
      !options.some(
        (o) => o.label.toLowerCase() === search.trim().toLowerCase(),
      )
    ) {
      options.unshift({
        value: search.trim(),
        label: `➕ Create "${search.trim().toUpperCase()}"`,
        __isNew__: true,
      });
    }

    return {
      options,
      hasMore: page * 10 < res.totalCount,
      additional: {
        page: page + 1,
      },
    };
  };

  return (
    <AsyncPaginate
      value={value}
      loadOptions={loadOptions}
      additional={{ page: 1 }}
      debounceTimeout={300}
      isClearable
      placeholder="Search Make..."
      onChange={(selected: any) => {
        if (selected?.__isNew__) {
          onChange({
            value: selected.value,
            label: selected.value.toUpperCase(),
            __isNew__: true,
          });
        } else {
          onChange(selected);
        }
      }}
    />
  );
}
